import React from 'react'
import './order.less'
import { buyInfoApi } from '@/api/shopping-car'
import { withRouter } from 'react-router-dom'
import { Toast } from 'antd-mobile'

@(withRouter as any)
class Order extends React.Component<any, any> {
  action = async (e: any, order: any) => {
    e.preventDefault()
    if (order.action.jump.jump_type === 'order_detail') {
      //订单详情
      this.props.history.push({
        pathname: `/order-detail/${order.action.jump.jump_value}`,
      })
    } else if (order.action.jump.jump_type === 'order_again') {
      //再来一单
      const { data } = await buyInfoApi(
        order.depot_id,
        order.action.jump.jump_value,
      )
      if (data.code !== 'SUCCESS') {
        Toast.info(data.msg, 1)
        return
      }
      let buyinfo = data.data.buy_info
      if (buyinfo.length > 0) {
        await sessionStorage.setItem('buyinfo', JSON.stringify(buyinfo))
        let { match } = this.props
        this.props.history.push({
          pathname: `/fillorder/prepare/${match.params.index}/${
            order.depot_id
          }`,
        })
      } else {
        Toast.info(data.data.message, 1)
      }
    }
  }
  navToDetail = (order: any) => {
    this.props.history.push({
      pathname: `/order-detail/${order.order_sn}`,
    })
  }
  render() {
    let order = this.props.order
    let list
    if (order.goods_list.length > 4) {
      list = order.goods_list.slice(0, 4)
    } else {
      list = order.goods_list
    }
    const goodsItems = list.map((item: any, index: number) => (
      <div className="img-div" key={index}>
        <img src={item.cover} alt="anxin.png" />
      </div>
    ))
    const satusItems = order.status.map((item: any, index: number) => (
      <div className="status-item" key={index}>
        <div className="order-img">
          <img src={item.icon} alt="anxin.png" />
          {index !== order.status.length - 1 && (
            <img
              src="/public/assets/img/order_status_line.png"
              alt="anxin.png"
            />
          )}
        </div>
        <div className="font-8" style={{ color: item.color }}>
          {item.text}
        </div>
      </div>
    ))
    return (
      <div className="order-list-item">
        <div onClick={() => this.navToDetail(order)} className="title font-7">
          <img
            className="logo"
            src={process.env.PUBLIC_URL + '/assets/img/shopping_cart_logo.png'}
            alt="anxin.png"
          />
          <span className="store-name">{order.depot_name}</span>
          <span className="text-ell">订单号: {order.order_sn}</span>
        </div>
        <div onClick={() => this.navToDetail(order)} className="img-info">
          {goodsItems}
        </div>
        <div onClick={() => this.navToDetail(order)} className="order-step">
          <div className="status"> {satusItems}</div>
          <span className="font_yellow">￥ {order.total_price}</span>
        </div>
        <div className="order-action">
          <span>{order.create_time}</span>
          <div
            className="button"
            style={{ background: order.action.style }}
            onClick={(e: any) => this.action(e, order)}
          >
            {order.action.text}
          </div>
        </div>
        <div />
      </div>
    )
  }
}

export default Order
